import { useQuery, useQueryClient } from '@tanstack/react-query';

export const usePassport = () => {
  const API_URL = import.meta.env.VITE_API_URL;
  const queryClient = useQueryClient();

	const { data : passport, isPending  } = useQuery({
  	queryKey: ['passport'],
  	queryFn: async () => {
   		const response = await fetch(`${API_URL}/bbs/ajax.get_passport.php`, {
      		credentials: 'include'
    		});

      	if (!response.ok) throw new Error("네트워크 오류");

  	  	return response.json();
  	},
  	staleTime: 0,
  	refetchOnWindowFocus: false,
  	retry: false
	});

	return {
		passport: passport?.data ?? null,
	  existPassport: passport?.success === true,
	  isPassportLoading: isPending,
	};
};